// Content data for Enterprise Portal

export interface Announcement {
  id: string
  title: string
  titleBM: string
  date: string
  content: string
  contentBM: string
  category: 'announcement' | 'media-statement' | 'withdrawal' | 'general'
  featured?: boolean
  pdfUrl?: string
}

export interface NewsItem {
  id: string
  title: string
  titleBM: string
  date: string
  excerpt: string
  excerptBM: string
  content: string
  contentBM: string
  image?: string
  category: string
  categoryBM: string
}

export interface SliderItem {
  id: string
  title: string
  titleBM: string
  image: string
  href?: string
  description?: string
  descriptionBM?: string
  isExternal?: boolean
}

export const announcements: Announcement[] = [
  {
    id: '202504246809bf6f8159e',
    title: 'MEDIA STATEMENT - ANNOUNCEMENT RECALL OF CERTIFIED FOOD PRODUCTS',
    titleBM:
      'KENYATAAN MEDIA - PENGUMUMAN PENARIKAN BALIK PRODUK MAKANAN BERSIJIL',
    date: '2025-04-24',
    content:
      'The company announces the recall of certain food products certified in Indonesia due to non-compliance with certification standards.',
    contentBM:
      'The company mengumumkan penarikan balik produk makanan tertentu yang disijilkan di Indonesia kerana tidak mematuhi piawaian pensijilan.',
    category: 'media-statement',
    featured: true,
  },
]

export const news: NewsItem[] = [
  {
    id: '2024102367189d4da3e20',
    title: 'Certification on Track @ Pahang Berlangsung Meriah',
    titleBM: 'Certification on Track @ Pahang Berlangsung Meriah',
    date: '2024-10-23',
    excerpt:
      'The Certification on Track program in Pahang was successfully conducted with enthusiastic participation from local businesses and entrepreneurs.',
    excerptBM:
      'Program Certification on Track di Pahang telah berjaya dijalankan dengan penyertaan yang memberangsangkan daripada perniagaan dan usahawan tempatan.',
    content:
      'The Certification on Track @ Pahang program was successfully held with great enthusiasm from participants. The program aimed to educate local businesses about certification processes and requirements.',
    contentBM:
      'Program Certification on Track @ Pahang telah berjaya diadakan dengan penuh semangat daripada peserta. Program ini bertujuan untuk mendidik perniagaan tempatan mengenai proses dan keperluan pensijilan.',
    category: 'Event',
    categoryBM: 'Acara',
  },
  {
    id: '2024101067189d4da3e21',
    title:
      'Advice Service Counter at the "Food: World Taste" Program at AEON Mall Shah Alam',
    titleBM:
      'Kaunter Perkhidmatan Nasihat di Program "Food: World Taste" di AEON Mall Shah Alam',
    date: '2024-10-08',
    excerpt:
      'The company set up an advice service counter at AEON Mall Shah Alam to provide guidance to the public about certification.',
    excerptBM:
      'The company telah menubuhkan kaunter perkhidmatan nasihat di AEON Mall Shah Alam untuk memberi panduan kepada orang ramai mengenai pensijilan.',
    content:
      'The Advice Service Counter was established at AEON Mall Shah Alam during the "Food: World Taste" program to provide direct consultation services to the public.',
    contentBM:
      'Kaunter Perkhidmatan Nasihat telah ditubuhkan di AEON Mall Shah Alam semasa program "Food: World Taste" untuk menyediakan perkhidmatan perundingan terus kepada orang ramai.',
    category: 'Service',
    categoryBM: 'Perkhidmatan',
  },
  {
    id: '2023122267189d4da3e22',
    title: 'Malaysian Certifications Procedure for International Manufacturing',
    titleBM: 'Prosedur Pensijilan Malaysia untuk Pembuatan Antarabangsa',
    date: '2023-12-22',
    excerpt:
      'New procedures for Malaysian certification for international manufacturing companies have been updated and implemented.',
    excerptBM:
      'Prosedur baharu untuk pensijilan Malaysia bagi syarikat pembuatan antarabangsa telah dikemas kini dan dilaksanakan.',
    content:
      'The updated procedures for Malaysian certification specifically for international manufacturing companies have been implemented to streamline the certification process.',
    contentBM:
      'Prosedur yang dikemas kini untuk pensijilan Malaysia khusus untuk syarikat pembuatan antarabangsa telah dilaksanakan untuk memperlancarkan proses pensijilan.',
    category: 'Procedure',
    categoryBM: 'Prosedur',
  },
]

export const sliderItems: SliderItem[] = [
  {
    id: 'ai-solutions',
    title: 'AI-Driven Enterprise Solutions',
    titleBM: 'Penyelesaian Enterprise Berasaskan AI',
    image: '/images/slider/ai_solutions.jpg',
    href: '#',
    isExternal: true,
    description: 'Transform your business with cutting-edge AI technology',
    descriptionBM:
      'Transformasikan perniagaan anda dengan teknologi AI terkini',
  },
  {
    id: 'digital-transformation',
    title: 'Digital Transformation Services',
    titleBM: 'Perkhidmatan Transformasi Digital',
    image: '/images/slider/digital_transformation.jpg',
    href: '#',
    isExternal: true,
    description: 'Comprehensive digital transformation for modern businesses',
    descriptionBM: 'Transformasi digital komprehensif untuk perniagaan moden',
  },
  {
    id: 'cloud-services',
    title: 'Cloud Infrastructure & Services',
    titleBM: 'Infrastruktur & Perkhidmatan Awan',
    image: '/images/slider/cloud_services.jpg',
    href: '#',
    isExternal: true,
    description: 'Scalable cloud solutions for enterprise growth',
    descriptionBM:
      'Penyelesaian awan yang boleh diskalakan untuk pertumbuhan enterprise',
  },
  {
    id: 'app-development',
    title: 'Custom Application Development',
    titleBM: 'Pembangunan Aplikasi Tersuai',
    image: '/images/slider/app_development.jpg',
    href: '#',
    isExternal: true,
    description: 'Bespoke software solutions tailored to your business needs',
    descriptionBM:
      'Penyelesaian perisian suai mengikut keperluan perniagaan anda',
  },
  {
    id: 'business-efficiency',
    title: 'Business Process Optimization',
    titleBM: 'Pengoptimuman Proses Perniagaan',
    image: '/images/slider/business_efficiency.jpg',
    href: '#',
    isExternal: true,
    description: 'Streamline operations and enhance business efficiency',
    descriptionBM: 'Kemudakan operasi dan tingkatkan kecekapan perniagaan',
  },
]

export const searchPlaceholders = {
  en: 'Enter company name, product name, or certificate number...',
  bm: 'Masukkan nama syarikat, nama produk, atau nombor sijil...',
}

export const eAduanInfo = {
  title: {
    en: 'E-Complaint',
    bm: 'Aduan Elektronik',
  },
  description: {
    en: 'Scan the QR code to create a complaint or click the button below.',
    bm: 'Imbas kod QR untuk membuat aduan atau klik butang di bawah.',
  },
  buttonText: {
    en: 'Create a complaint',
    bm: 'Buat aduan',
  },
  qrImage: '/images/icons/aduan_qr.png',
  url: 'https://example.com/support',
}
